import React from 'react'
import { Button } from '@material-ui/core'
const NoDataFound = () => {
    return (
        <div id="notfound">
            <div class="notfound">
                <div class="notfound-404">
                    <h1>Oops!</h1>
                    <h2>No data available</h2>
                </div>
                <Button onClick={() => window.location.href = "/"}>Go TO Homepage</Button>

            </div>
        </div>
    )
}

export default NoDataFound